import { supabase } from "./supabaseClient";
import { fetchMyAccount } from "./accountApi";

// Records a sign-in to the app, under the login's account. Never blocks
// signing in if it fails. A login with no account isn't logged (the database
// rules only accept entries for your own account).
export async function logSignIn(userId) {
  try {
    const account = await fetchMyAccount(userId);
    if (!account) return;
    const { error } = await supabase.from("activity_log").insert({
      agency_id: account.agencyId,
      user_id: userId,
      type: "app_sign_in",
    });
    if (error) console.error("logSignIn", error);
  } catch (e) {
    console.error("logSignIn", e);
  }
}
